import { getOperatorSymbol, NOT_ONE_OF, ONE_OF } from '../Operators';
import { STRING } from '../ColumnType';
import { ALL_SPECIFIC_TIMES } from '../../components/modals/ModalWhere';
import { MONTH, QUARTER, WEEK, YEAR } from '../enums/EnumDateTimeAggregation';
import { formatValueToShow, getEndOfWeek } from './time-helpers';
import LayerWhere from '../../components/layers/LayerWhere';
import AggregateColumn from '../AggregateColumn';
import { dateFormat } from './time-helpers-ts';

export function buildClause(clause: LayerWhere) {
  return `${formatColumnName(
    clause.lhs(),
    clause.rhsValue(),
  )} ${getOperatorSymbol(clause.operator())} ${formatRhs(clause)}`;
}

function formatColumnName(lhs: AggregateColumn, rhs: string | null): string {
  const name = lhs.name();
  const aggregation = lhs.aggregation();
  // @ts-expect-error: null | string where string is expected
  return ALL_SPECIFIC_TIMES.includes(rhs) || !aggregation
    ? name
    : `${name} :: ${aggregation}`;
}

function formatRhs(clause: LayerWhere): string {
  const rhs = clause.rhsValue();
  const aggregation = clause.lhs().aggregation();

  if (clause.rhsColumn()) {
    return clause.rhsColumn()?.name() ?? '';
  }

  if (!rhs) {
    return rhs === '' ? 'EMPTY' : 'NULL';
  }

  if (clause.operator() === ONE_OF || clause.operator() === NOT_ONE_OF) {
    return formatLongString(rhs);
  }

  if (clause.expressionType().type() === STRING) {
    return `'${rhs}'`;
  }

  if (aggregation && !ALL_SPECIFIC_TIMES.includes(rhs)) {
    switch (aggregation) {
      case WEEK:
        return `${formatValueToShow(rhs, aggregation)} to ${getEndOfWeek(rhs)}`;
      case MONTH:
      case YEAR:
        // @ts-expect-error: formatValueToShow returns null | string where string is expected
        return formatValueToShow(rhs, aggregation);
      case QUARTER:
        return dateFormat(rhs, '\\QQ YYYY');
      default:
        break;
    }
  }

  return rhs;
}

function formatLongString(rhs: string) {
  const formatted = rhs
    .split('\n')
    .map((s) => `'${s}'`)
    .join(', ');
  if (formatted.length > 100) {
    return `${formatted.substring(0, 100)}... etc.`;
  }

  return formatted;
}
